import { AccountingReportType } from "@common/types/reports/report-type";
import { PreviewDatasetSource } from "../previewTypes";
import { PROFIT_LOSS_DATASET } from "./profitLoss";
import { BALANCE_SHEET_DATASET } from "./balanceSheet";
import { TRIAL_BALANCE_DATASET } from "./trialBalance";
import { CASH_FLOW_DATASET } from "./cashFlow";
import { GENERAL_LEDGER_DATASET } from "./generalLedger";
import { EXPENSE_BY_VENDOR_DATASET } from "./expenseByVendor";
import { SCHEDULES_DATASET } from "./schedules";
import { AR_AGING_SUMMARY_DATASET } from "./arAgingSummary";
import { AR_AGING_DETAIL_DATASET } from "./arAgingDetail";

const PREVIEW_DATASETS: Partial<
    Record<AccountingReportType, PreviewDatasetSource>
> = {
    [AccountingReportType.PROFIT_LOSS]: PROFIT_LOSS_DATASET,
    [AccountingReportType.BALANCE_SHEET]: BALANCE_SHEET_DATASET,
    [AccountingReportType.TRIAL_BALANCE]: TRIAL_BALANCE_DATASET,
    [AccountingReportType.CASH_FLOW_STATEMENT]: CASH_FLOW_DATASET,
    [AccountingReportType.GENERAL_LEDGER]: GENERAL_LEDGER_DATASET,
    [AccountingReportType.EXPENSE_BY_VENDOR]: EXPENSE_BY_VENDOR_DATASET,
    [AccountingReportType.SCHEDULES]: SCHEDULES_DATASET,
    [AccountingReportType.AR_AGING_SUMMARY]: AR_AGING_SUMMARY_DATASET,
    [AccountingReportType.AR_AGING_DETAIL]: AR_AGING_DETAIL_DATASET,
};

export const getPreviewDataset = (
    reportType: AccountingReportType,
): PreviewDatasetSource => PREVIEW_DATASETS[reportType] ?? PROFIT_LOSS_DATASET;
